import { render } from "./Calificaciones.vue?vue&type=template&id=7ba37ed7&scoped=true"
import script from "./Calificaciones.vue?vue&type=script&lang=js"
export * from "./Calificaciones.vue?vue&type=script&lang=js"

import "./Calificaciones.vue?vue&type=style&index=0&id=7ba37ed7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba37ed7"]])

export default __exports__